import $ from "jquery"
import {AccessRights, UserManagementConstants} from '../../constants'
import AccountSettings from "./accountSettings/AccountSettings"
import Permissions from "./permissions/Permissions"
import PermissionsTemplatesButtonController from "../../administration/userManagement/permissionsTemplates/PermissionsTemplatesButtonController"
import PermissionsDescriptionLightBox from "../../administration/userManagement/PermissionsDescriptionLightBox"
import {GROUP_NEW_OR_NOT_KNOWN, TabKeys, UserTeamAssignmentType, ValidationErrorsScrollClassesPriority, ValidationErrorsToScrollClasses} from "./constants"
import UserPanelContent from "./editPanel/UserPanelContent"
import TemplateView from "../../TemplateView"
import ScrollableContainer from "../../util/ScrollableContainer"
import {adjustPanelSize} from "./utils"
import {setEventPreventHidingEditUserSlidingPanel, setEventPreventHidingManagementAssignmentsSlidingPanel} from '../utils'
import {HierarchyLevels, ManagementAssignmentsSelection} from 'constants'
import ScrollUtils from '../../util/ScrollUtils'
import {setHasLeavesOrTTBeforeNewHireDateError} from './editPanel/actions'
import {addDefaultUserGroup} from '../../util/groupUtils'

export const MODE = {
    CREATE: "create",
    EDIT: "edit"
}

export default class UserPanelContainer extends TemplateView {

    constructor({
        accountSettingsId,
        mode,
        actions = {
            updateFirstName: () => {},
            updateLastName: () => {},
            updateMiddleName: () => {},
            updateUserName: () => {},
            updateEmail: () => {},
            updatePassword: () => {},
            updateUserGroup: () => {},
            updateTimeZoneGroup: () => {},
            validateTimeZoneGroup: () => {},
            updateHireDate: () => {},
            setHasLeavesOrTTBeforeNewHireDateError: () => {},
            updateReleaseDate: () => {},
            updateUserRights: () => {},
            updateAccess: () => {},
            updateAccessAP: () => {},
            updateRequireApproval: () => {},
            updateUserSchedules: () => {},
            updateInitialUserSchedule: () => {},
            deleteUserSchedule: () => {},
            updateOvertime: () => {},
            changeTeamAssignments: () => {},
            openManagementAssignmentPanel: () => {},
            restoreState: () => {},
            setUserManagementData: () => {},
            setLastLicenseManagerOnDeleteAlertShown: () => {},
            setLastLicenseManagerOnDisableAtAlertShown: () => {},
            setLastLicenseManagerOnDisableApAlertShown: () => {},
        }
    }) {
        super(null);

        this.params = {
            accountSettingsId,
            mode
        }

        this.actions = actions

        this.state = {
            updatingData: false,
            loggedInUserId: null,
            userId: null,
            selectedTab: TabKeys.ACCOUNT_SETTINGS,
            fullUserInfo: {
                firstName: null,
                lastName: null,
                middleInitial: null,
                username: null,
                email: null,
                password: "",
                retypedPassword: "",
                userGroupId: null,
                timeZoneGroupId: null,
                hireDate: (new Date()).toJSON(),
                releaseDate: null,
                enabled: false,
                enabledInOtherProduct: false,
                overtimeLevel: 1,
                accessRights: [],
                rates: [],
                requiresTTApproval: false,
                initialSchedule: [],
                defaultInitialSchedule: true,
                workSchedule: [],
            },
            userGroupRowData: {
                groupId: null,
                newGroupCreating: false,
            },
            timeZoneGroupRowData: {
                groupId: null,
                newGroupCreating: false,
                timeZoneGroupOffsets: {},
            },
            userTeamAssignmentsData: {
                teamAssignmentType: UserTeamAssignmentType.SELECTED,
                assignedGroups: [],
                assignedUsers: [],
                assignedUsersCount: 0,
            },
            userManageAssignmentsData: {
                managementAssignmentsSelection: ManagementAssignmentsSelection.SELECTED,
                customers: {},
                projects: {},
                tasks: {},
                customerAssignments: [],
                projectAssignments: [],
                taskAssignments: [],
                taskCountsByProjects: {},
                projectCountsByCustomers: {}
            },
            managementAssignmentsCounts: {
                customers: 0,
                projects: 0,
                tasks: 0
            },
            allApprovers: {},
            userManagementData: {
                activeLeaveTypes: [],
                overtimeRateCoefficient: 0,
                decimalSeparator: '.',
                dateFormat: 'MMM dd, yyyy',
                defaultWorkSchedule: [],
                invertedDaysMap: {},
                weekStartDay: 1,
                permissionsTemplates: [],
                viewerSettings: {
                    enabledFeatures: {},
                    allowedToManageLeaveBalanceSettings: false,
                    allowedToManageScope: false,
                    hasAccessToScopeOfWork: false,
                    hasAccessToUsers: false,
                    allowedToManageAccountSettings: false,
                    assignedUserIds: null,
                    showAccountSettings: false
                },
                todayInViewerTimeZone: (new Date()).toJSON(),
                allTimeZoneGroupOffsets: {},
            },
            allUserGroups: [],
            allTimeZoneGroups: [],
            extendedData: {
                lastLoginTime: null,
                firstTTDate: null,
                hasTimeTrack: false,
                lastOtherProductAdmin: false,
                lastLicensesManager: false,
                currentTime: (new Date()).toJSON(),
                isAllowedToSeeAllUsersTT: false,
            },
            providerErrors: {},
            passwordValidationResult: null,
            hasLeavesOrTTBeforeNewHireDateError: false,
            isUGREnabled: false,
            isTZGEnabled: false,
            isURAEnabled: false,
            isTTAEnabled: false,
            updatingUserRates: false,
            updatingWorkSchedule: false,
            isBTYEnabled: false,
            isLTTEnabled: false,
            isPTOEnabled: false,
            idSDBEnabled: false,
            isOVREnabled: false,

            baseAccountInformationEditable: false,
            accessToActiTimeEditable: false,
            accessToActiPlansEditable: false,
            departmentEditable: false,
            timeZoneEditable: false,
            hireAndReleaseDatesEditable: false,
            approvalSettingsEditable: false,
            workScheduleEditable: false,
            overtimeSettingsEditable: false,
            costOfWorkRatesEditable: false,

            permissionsEditable: false,
            teamScopeEditable: false,
            manageScopeEditable: false,

            hasRightsToDeleteUser: false,

            loaded: false,
        }

        this.onStatePropertyChanged('updatingData', loading => {
            this.header.setState({updateLoading: loading})
            this.permissionsTab.setState({disabled: loading})
        })

        this.onStatePropertyChanged('loaded', loaded => {
            this.accountSettingsTab.setState({loaded})

        })

        this.onStatePropertyChanged('selectedTab', currentTabKey => {
            this.userPanelContent.setState({currentTabKey})
            this.userPanelContentWrapper.forceUpdate()
            this.scrollToTop()
        })

        this.onStatePropertyChanged('userId', userId => {
            if (userId !== null) {
                this.scrollToTop()
            }
        })

        this.onStatePropertyChanged('fullUserInfo', fullUserInfo => this._onFullUserInfoChanged(fullUserInfo))
        this.onStatePropertyChanged('userGroupRowData', userGroupRowData => this.userGroupRow.setState(userGroupRowData))
        this.onStatePropertyChanged('timeZoneGroupRowData', timeZoneGroupRowData => this.timeZoneGroupRow.setState(timeZoneGroupRowData))
        this.onStatePropertyChanged('userManagementData', userManagementData => this._onUserManagementDataChanged(userManagementData))
        this.onStatePropertyChanged('userManageAssignmentsData', ma => this._onUserManageAssignmentsDataChanged(ma))
        this.onStatePropertyChanged('managementAssignmentsCounts', counts => this._onManagementAssignmentsCountsChanged(counts))
        this.onStatePropertyChanged('userTeamAssignmentsData', ta => this._onUserTeamAssignmentsDataChanged(ta))
        this.onStatePropertyChanged('extendedData', extendedData => this._onExtendedDataChanged(extendedData))
        this.onStatePropertyChanged('allUserGroups', userGroups => this._onUserGroupsChanged(userGroups))
        this.onStatePropertyChanged('allTimeZoneGroups', allTimeZoneGroups => this._onTimeZoneGroupsChanged(allTimeZoneGroups))

        this.onStatePropertyChanged('providerErrors', providerErrors => {
            this.accountSettingsTab.accountInformation.setState({providerErrors})
            this.userGroupRow.setState({errors: providerErrors})
            this.timeZoneGroupRow.setState({errors: providerErrors})
        })
        this.onStatePropertyChanged('passwordValidationResult', passwordValidationResult => {
            this.accountSettingsTab.accountInformation.setState({passwordValidationResult})
        });
        this.onStatePropertyChanged('hasLeavesOrTTBeforeNewHireDateError', hasLeavesOrTTBeforeNewHireDateError => {
            this.accountSettingsTab.accountInformation.setState({hasLeavesOrTTBeforeNewHireDateError: hasLeavesOrTTBeforeNewHireDateError})
        })

        this.onStatePropertyChanged('isUGREnabled', isUGREnabled => {
            this.permissionsTab.setState({
                isUGREnabled: isUGREnabled
            })
            this.userGroupRow.toggle(isUGREnabled)
        })

        this.onStatePropertyChanged('departmentEditable', editable => {
            this.userGroupRow.setState({editable})
        })

        this.onStatePropertyChanged('timeZoneEditable', editable => {
            this.timeZoneGroupRow.setState({editable})
        })

        this.onStatePropertyChanged('isTZGEnabled', isTZGEnabled => {
            this.timeZoneGroupRow.toggle(isTZGEnabled)
        })

        this.onStatePropertyChanged('updatingUserRates', updatingUserRates => {
            this.accountSettingsTab.setState({updatingUserRates})
        })

        this.onStatePropertyChanged('updatingWorkSchedule', updating => this.accountSettingsTab.workSchedule.setState({updating}))

        this.onStatePropertyChanged('isURAEnabled', isURAEnabled => {
            this.permissionsTab.setState({isURAEnabled})
            this.accountSettingsTab.setState({showUserRates: isURAEnabled})
            this.permissionsTemplatesButtonController.setState({isURAEnabled})
        })

        this.onStatePropertyChanged('isBTYEnabled', enabled => {
            this.permissionsTab.setState({
                isBTYEnabled: enabled
            })
            this.permissionsTemplatesButtonController.setState({isBTYEnabled : enabled})
        })

        this.onStatePropertyChanged('isLTTEnabled', enabled => {
            this.permissionsTab.setState({
                isLTTEnabled: enabled
            })

            this.permissionsTemplatesButtonController.setState({isLTTEnabled: enabled})
        })
        this.onStatePropertyChanged('isPTOEnabled', enabled => {
            this.permissionsTab.setState({
                isPTOEnabled: enabled
            })

            this.permissionsTemplatesButtonController.setState({isPTOEnabled : enabled})
        })

        this.onStatePropertyChanged('isSDBEnabled', enabled => {
            this.permissionsTab.setState({
                isSDBEnabled: enabled
            })

            this.permissionsTemplatesButtonController.setState({isSDBEnabled : enabled})
        })

        this.onStatePropertyChanged('isOVREnabled', enabled => {
            this.accountSettingsTab.setState({
                showOvertime: enabled
            })
        })

        this.onStatePropertyChanged('baseAccountInformationEditable', baseAccountInformationEditable => {
            this.accountSettingsTab.accountInformation.setState({baseAccountInformationReadOnly: !baseAccountInformationEditable})
        })

        this.onStatePropertyChanged('accessToActiPlansEditable', accessToActiPlansEditable => {
            this.accountSettingsTab.accountInformation.setState({accessToActiPlansEditable})
        })

        this.onStatePropertyChanged('accessToActiTimeEditable', accessToActiTimeEditable => {
            this.accountSettingsTab.accountInformation.setState({accessToActiTimeEditable})
        })

        this.onStatePropertyChanged('hireAndReleaseDatesEditable', editable => {
            this.accountSettingsTab.accountInformation.setState({hireAndReleaseDatesEditable : editable})
        })

        this.onAnyStatePropertyChanged(['approvalSettingsEditable'], () => {
            this.accountSettingsTab.timeTrackApprovalSetting.setState({editable: this.state.approvalSettingsEditable})
        })

        this.onStatePropertyChanged('workScheduleEditable', (editable) => {
            this.accountSettingsTab.workSchedule.setState({readOnly : !editable})
        })

        this.onStatePropertyChanged('overtimeSettingsEditable', (editable) => {
            if (!!this.accountSettingsTab.overtime)
                this.accountSettingsTab.overtime.setState({readOnly: !editable})
        })

        this.onAnyStatePropertyChanged(['permissionsEditable', 'teamScopeEditable', 'manageScopeEditable'], () => {
            this.permissionsTab.setState({
                permissionsReadOnly: !this.state.permissionsEditable,
                teamScopeReadOnly: !this.state.teamScopeEditable,
                manageScopeReadOnly: !this.state.manageScopeEditable,
            })
        })

        this.onStatePropertyChanged('hasRightsToDeleteUser', (hasRightsToDelete) => this.header.setState({noRightsToDelete : !hasRightsToDelete}))

        this.onStateChanged(() => {
            this.userPanelContentWrapper.forceUpdate()
        })
    }

    templateHtml() {
        return '<div class="userPanelContainer">' +
               '    <div class="panelHeader"/>' +
               '    <div class="panelContent"/>' +
               '    <div class="panelFooter"/>' +
               '</div>'
    }

    afterRender() {
        this.$header = this.find('.panelHeader')
        this.$footer = this.find('.panelFooter')

        this.userGroupRow = this._createUserGroupRowComponent()
        this.timeZoneGroupRow = this._createTimeZoneGroupRowComponent()

        this.accountSettingsTab = new AccountSettings({
            wrapperId: this.params.accountSettingsId,
            mode: this.params.mode,
            userGroupRow: this.userGroupRow,
            timeZoneGroupRow: this.timeZoneGroupRow,
            onInitialScheduleChanged: this.actions.updateInitialUserSchedule,
            onWorkScheduleChanged: this.actions.updateUserSchedules,
            deleteWorkSchedule: this.actions.deleteUserSchedule,
            addNewSchedule: this.actions.addNewSchedule,
            refreshScrollCb: () => this.userPanelContentWrapper.forceUpdate(),
            scrollToElement: ($element) => this.scrollToElementInstant($element),
            scrollToTop: () => this.scrollToTop(),
            restoreState: this.actions.restoreState,
        })

        this.permissionsTab = new Permissions(null, {
            onTeamAssignmentsCellClick: this._handleTeamAssignmentsPanelVisibility,
            onManagementAssignmentsCellClick: this._handleManagementAssignmentsCellClick
        })
        this.permissionsTab.setState({
            isUGREnabled: this.state.isUGREnabled
        })

        this.userPanelContent = new UserPanelContent({
            $headerTabs: {
                $accountSettingsTab: this.header.$accountSettingsTab,
                $permissionsTab: this.header.$permissionsTab
            },
            accountSettings: this.accountSettingsTab,
            permissions: this.permissionsTab,
            tabSwitchedCallback: (tabKey) => this.actions.switchTab(tabKey)
        })

        this.userPanelContentWrapper = new ScrollableContainer(null, this.userPanelContent, {
            containerClass: "userPanelContent",
            iScrollParams: {
                probeType: 2
            },
            onScrollCb: () => {
                this.userPanelContent.onScroll()
            }
        })
        this.userPanelContentWrapper.init(this.find('.panelContent'))

        this.permissionsTemplatesButtonController = new PermissionsTemplatesButtonController({
            $containerEl: this.permissionsTab.$templatePanel,
            $button: this.permissionsTab.permissionsBlock.$permissionTemplatesMenuButton,
            withoutChoosing: false,
            onChangeDialogVisibility: this._handleChangePermissionsDialogVisibility,
            onChangeTemplates: this._handleChangePermissionsTemplates
    }
        ).init();

        this.subscribeForEvents();

        this.registerChildComponents(
            this.accountSettingsTab,
            this.permissionsTab,
            this.userPanelContent,
        )
    }

    adjustSize() {
        this.userPanelContentWrapper.forceUpdate()
    }

    scrollToTop() {
        this.userPanelContentWrapper.scrollToTop()
    }

    scrollToElement($element) {
        this.userPanelContentWrapper.scrollToElementVertical($element,
            {
                pos: ScrollUtils.POSITIONS.TOP,
            },
            800)
    }

    scrollToElementInstant($element) {
        this.userPanelContentWrapper.scrollToElementVertical($element,
            {
                pos: ScrollUtils.POSITIONS.TOP,
            }, 0)
    }

    scrollToError(providerErrors) {
        if (!$.isEmptyObject(providerErrors)) {
            let maxPriority = 0
            let maxPriorityError = ''
            for (let error in providerErrors) {
                const errorClass = ValidationErrorsToScrollClasses[error]
                if (!errorClass) {
                    console.warn("No scroll class for error ", error, " -> skip");
                    continue;
                }
                let nextPriority = ValidationErrorsScrollClassesPriority[errorClass]
                if (nextPriority > maxPriority) {
                    maxPriority = nextPriority
                    maxPriorityError = errorClass
                }
            }
            this.scrollToElement(this.userPanelContent.find(`.${maxPriorityError}`))
        }
    }

    show() {
        super.show()
        this.userPanelContentWrapper.forceUpdate()
    }

    _onChangePermissions(rights, editUserIsLoggedIn) {
        // cannot remove manage users permission from yourself
        const canManageUsers = rights.indexOf(AccessRights.MANAGE_USERS) === -1
        if (editUserIsLoggedIn && canManageUsers) {
            rights.push(AccessRights.MANAGE_USERS);
        }
        this.actions.updateUserRights(rights, false)
    }

    subscribeForEvents() {
        const accountInformation = this.accountSettingsTab.accountInformation;
        accountInformation.on('changeFirstName', (e, newName) => {
            this.actions.updateFirstName(newName)
        });

        accountInformation.on('changeLastName', (e, newName) => {
            this.actions.updateLastName(newName)
        });

        accountInformation.on('changeMiddleName', (e, newName) => {
            this.actions.updateMiddleName(newName)
        });

        accountInformation.on('changeEmail', (e, email) => {
            this.actions.updateEmail(email)
        });

        const timetrackApprovalSetting = this.accountSettingsTab.timeTrackApprovalSetting;

        accountInformation.on('changeUsername', (e, username, duplicateError) => {
            this.actions.updateUserName(username, duplicateError)
        });

        accountInformation.on('changePassword', (e, password, retypedPassword, isPasswordChanged, isPasswordCopyChanged) => {
            this.actions.updatePassword(password, retypedPassword, isPasswordChanged, isPasswordCopyChanged)
        });

        accountInformation.on('changeHireDate', (e, hireDate, needToRemoveDataHandler) => {
            let forceUpdate = false
            this.actions.updateHireDate(hireDate, forceUpdate, needToRemoveDataHandler)
        })

        accountInformation.on('forceChangeHireDate', (e, hireDate) => {
            const forceUpdate = true
            this.actions.updateHireDate(hireDate, forceUpdate)
        })

        accountInformation.on('setHasLeavesOrTTBeforeNewHireDateError', (e, hasLeavesOrTTBeforeNewHireDateError) => {
            this.actions.setHasLeavesOrTTBeforeNewHireDateError(hasLeavesOrTTBeforeNewHireDateError)
        })

        accountInformation.on('changeReleaseDate', (e, releaseDate) => {
            this.actions.updateReleaseDate(releaseDate)
        });

        timetrackApprovalSetting.on('changeApprovalState', (e, needApproval) => {
            this.actions.updateRequireApproval(needApproval)
        });

        const overtime = this.accountSettingsTab.overtime;
        if (overtime) {
            overtime.on('changeOvertime', (e, overtimeLevel) => {
                this.actions.updateOvertime(overtimeLevel)
            });
        }

        this.permissionsTab.permissionsBlock.on(
            'permissionsChanged',
            (e, rights, userLoggedIn) => this._onChangePermissions(rights, userLoggedIn)
        );

        new PermissionsDescriptionLightBox({
            onClickDialogContent: (e) => setEventPreventHidingEditUserSlidingPanel(e),
        }).init(this.permissionsTab.$permissionsInfoButton);

        $(this.permissionsTemplatesButtonController).on(
            'applyTemplate',
            (e, rights, userLoggedIn) => this._onChangePermissions(rights, userLoggedIn)
        );
    }

    _onFullUserInfoChanged(fullUserInfo) {
        this.header.setState({
            ...fullUserInfo,
            loggedIn: fullUserInfo.id ? fullUserInfo.id === this.state.loggedInUserId : false,
        })

        this.accountSettingsTab.accountInformation.setState({
            ...fullUserInfo,
            editUserIsLoggedIn: this.state.loggedInUserId === fullUserInfo.id,
            userId: fullUserInfo.id,
        })

        this.accountSettingsTab.workSchedule.setState({
            accountSettings: fullUserInfo,
            userManagementData: this.state.userManagementData,
            currentTime: this.state.extendedData.currentTime,
        })

        if (this.accountSettingsTab.overtime) {
            this.accountSettingsTab.overtime.setState({
                overtimeLevel: fullUserInfo.overtimeLevel
            });
        }

        const groupId = fullUserInfo.userGroupId;
        const isUGREnabled = this.state.isUGREnabled

        let nameGroup = '';
        if (groupId !== GROUP_NEW_OR_NOT_KNOWN && groupId !== UserManagementConstants.USER_GROUP_NOT_ASSIGNED_ID && isUGREnabled) {
            let group = this.state.allUserGroups.find(group => group.id === groupId)
            nameGroup = (group) ? group.name : '';
        }

        this.accountSettingsTab.timeTrackApprovalSetting.setState({
            requiresTTApproval: fullUserInfo.requiresTTApproval,
            nameGroup: nameGroup,
        })

        this.permissionsTab.setState({
            editUserIsLoggedIn: fullUserInfo.id ? fullUserInfo.id === this.state.loggedInUserId : false,
            accessRights: fullUserInfo.accessRights,
            manageAssignmentsData: this.state.userManageAssignmentsData,
            teamAssignmentsData: this.state.userTeamAssignmentsData,
            userFirstName: fullUserInfo.firstName,
        });

        this.permissionsTemplatesButtonController.setState({
            editUserIsLoggedIn: fullUserInfo.id === this.state.loggedInUserId
        });
    }

    _onUserManagementDataChanged(userManagementData) {
        this.accountSettingsTab.accountInformation.setState({
            userManagementData: {
                ...userManagementData,
                userGroups: this.state.allUserGroups,
                timeZoneGroups: this.state.allTimeZoneGroups,
            },
        });

        this.accountSettingsTab.workSchedule.setState({userManagementData})

        const isUGREnabled = this.state.isUGREnabled
        const isTTAEnabled = this.state.isTTAEnabled

        this.accountSettingsTab.timeTrackApprovalSetting.setState({
            isUGREnabled: isUGREnabled,
            isTTAEnabled: isTTAEnabled
        })

        this.permissionsTemplatesButtonController.setState({
            templates: userManagementData.permissionsTemplates
        });
    }

    _onUserGroupsChanged(userGroups) {
        this.accountSettingsTab.accountInformation.setState({
            userManagementData: {
                ...this.state.userManagementData,
                userGroups: this.state.allUserGroups,
                timeZoneGroups: this.state.allTimeZoneGroups,
            },
        })
        this.userGroupRow.setState({userGroups})
        this.permissionsTab.setState({
            userGroups: addDefaultUserGroup(userGroups)
        })
    }

    _onTimeZoneGroupsChanged(timeZoneGroups) {
        this.accountSettingsTab.accountInformation.setState({
            userManagementData: {
                ...this.state.userManagementData,
                userGroups: this.state.allUserGroups,
                timeZoneGroups: this.state.allTimeZoneGroups,
            },
        })
        this.timeZoneGroupRow.setState({timeZoneGroups})
    }

    _onUserManageAssignmentsDataChanged(userManageAssignmentsData) {
        this.permissionsTab.setState({
            managementAssignmentsSelection: userManageAssignmentsData.managementAssignmentsSelection,
        });
    }

    _onManagementAssignmentsCountsChanged(counts) {
        this.permissionsTab.setState({
            managementAssignmentsCounts: counts,
        });
    }

    _onUserTeamAssignmentsDataChanged(userTeamAssignmentsData) {
        this.permissionsTab.setState({
            teamAssignmentsData: userTeamAssignmentsData,
        });
    }

    _onExtendedDataChanged(extendedData) {
        this.header.setState({
            lastLoginTime: extendedData.lastLoginTime,
            hasTimeTrack: extendedData.hasTimeTrack,
            lastOtherProductAdmin: extendedData.lastOtherProductAdmin,
        });

        const currentTime = extendedData.currentTime;

        this.accountSettingsTab.accountInformation.setState({
            firstTTDate: extendedData.firstTTDate ? Date.parseJSONDate(extendedData.firstTTDate) : null,
            firstRequestDate: extendedData.firstRequestDate ? Date.parseJSONDate(extendedData.firstLeaveRequestDate) : null,
            currentTime: currentTime,
        });

        this.accountSettingsTab.workSchedule.setState({
            currentTime: currentTime,
        })

        this.permissionsTab.setState({
            isAllowedToSeeAllUsersTT: this.state.extendedData.isAllowedToSeeAllUsersTT ? this.state.extendedData.isAllowedToSeeAllUsersTT : false,
        })
    }

    _handleTeamAssignmentsPanelVisibility = (visible, e) => {}

    _handleManagementAssignmentsCellClick = (e) => {
        setEventPreventHidingManagementAssignmentsSlidingPanel(e)
        this.actions.openManagementAssignmentPanel(this.state.userId, HierarchyLevels.CUSTOMER)
    }


    _handleChangeCustomersSelectorVisibility = (visible) => {
        this.permissionsTab.getEl().toggleClass('customersSelectorOpen', visible)
        this.userPanelContentWrapper.forceUpdate()
    }

    _handleChangeProjectsSelectorVisibility = (visible) => {
        this.permissionsTab.getEl().toggleClass('projectsSelectorOpen', visible)
        this.userPanelContentWrapper.forceUpdate()
    }

    _handleChangeTasksSelectorVisibility = (visible) => {
        this.permissionsTab.getEl().toggleClass('tasksSelectorOpen', visible)
        this.userPanelContentWrapper.forceUpdate()
    }

    _handleChangePermissionsDialogVisibility = (visible) => {
        this.permissionsTab.getEl().toggleClass('permissionsDialogOpen', visible)
        this.userPanelContentWrapper.forceUpdate()
    }

    _handleChangePermissionsTemplates = ({templates, permissions, userLoggedIn}) => {
        this._onChangePermissions(permissions, userLoggedIn)
        this.actions.setUserManagementData({
            permissionsTemplates: templates
        })
    }

    _createUserGroupRowComponent() {
        // abstract
    }

    _createTimeZoneGroupRowComponent() {
        // abstract
    }
}



// WEBPACK FOOTER //
// ./web/js/panels/user/UserPanelContainer.js